import React from 'react';

export default function PermissionDenied() {
    return (
        <main><p className="text-danger">Sorry, Permission denied</p></main>
    );
} 